<template>
  <VDialog
    v-model:visible="visible"
    :show-header="false"
    modal
    class="mx-3 pt-3"
    style="width: 60ch; max-width: 100%"
  >
    <p>Following Address could not be verified:</p>
    <p>{{ address }}</p>

    <p>Would you like to vouch for the validity of this address?</p>

    <div class="mt-3 gap-2 d-flex justify-content-end">
      <button class="btn btn-secondary" @click="confirm">Yes</button>
      <button class="btn btn-primary" @click="deny">No</button>
    </div>
  </VDialog>
</template>

<script setup lang="ts">
import VDialog from "primevue/dialog";

defineProps<{
  address: string;
}>();

const emit = defineEmits<{
  vouched: [];
}>();

const visible = defineModel<boolean>("visible");

const confirm = () => {
  emit("vouched");
  visible.value = false;
};

const deny = () => {
  visible.value = false;
};
</script>
